import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminWallets = async (params = {}) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get("/v1/wallet/admin/wallets", {
      params: { page, page_size: pageSize },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
